import React from 'react';
import {Text, Icon} from '@/ui-kits';
import {SpecialistFeedBack} from '@/interface';
import {useNavigate} from 'react-router-dom';
import {Routes} from '@/navigation/Routes';
import { cn, formatName } from '@/utils/common_functions';

interface RecentFeedbackProps {
  feedbacks: SpecialistFeedBack[];
  className?: string
}

export const RecentFeedback: React.FC<RecentFeedbackProps> = ({feedbacks, className=''}) => {
  const navigate = useNavigate();
  return (
    <div className={cn("border-2 border-gray-300 rounded-xl p-6 bg-ui_bg_pale_blue shadow-sm", className)}>
      {/* Header */}
      <div className="flex items-center justify-between mb-5 flex-wrap min-w-0">
        <div className="flex items-center gap-2 min-w-0">
          <div className="p-2 border-2 border-gray-100 rounded-lg bg-white flex-shrink-0">
            <Icon type="happy_heart" className="text-ui_blue size-7" />
          </div>
          <Text variant="headingSemiBold" className="text-ui_blue break-words max-[374px]:!text-2xl">
            Recent Feedback
          </Text>
        </div>
        {/* {feedbacks.length > 1 && (
          <button onClick={() => navigate(Routes.RATINGS)} className="hidden sm:block text-ui_blue font-FigtreeMedium text-sm underline hover:opacity-80 transition-all flex-shrink-0">
            View All
          </button>
        )} */}
      </div>

      {/* Feedback List */}
      <div className="flex flex-col gap-3">
        {feedbacks.map((feedback, index) => (
          <div
            key={feedback.id}
            className="flex items-center justify-between p-4 bg-white rounded-lg border-2 border-gray-300 hover:bg-gray-50 transition-colors shadow-sm">
            {/* Left - Feedback Info */}
            <div className="flex flex-col gap-1 flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap min-w-0">
                <Text variant="title" className="text-ui_blue font-FigtreeSemiBold break-words !text-sm sm:!text-base min-w-0">
                  {formatName(feedback.patient_name)}
                </Text>
                <Text className="text-ui_input_border_dark !text-xs sm:!text-sm break-words min-w-0">
                  ( Case ID: <span className="font-FigtreeSemiBold">#{feedback.id}</span> )
                </Text>
              </div>
              <Text className="text-ui_input_border_dark text-sm">"{feedback.feedback}"</Text>
            </div>

            {/* Right - Rating */}
            <div className="flex items-start gap-1.5 flex-shrink-0 ml-4 pt-5">
              <Icon type="star_yellow" className="text-yellow-400" />
              <Text className="text-ui_blue font-FigtreeSemiBold text-lg">{feedback.rating}</Text>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

